import React, { Component, FunctionComponent, useState } from 'react'
import { BrowserRouter, Redirect, Route, useHistory, useLocation } from 'react-router-dom'
import './App.scss'
import { axios, browserInfo, urlSearch } from './utils/tools'
import Details from './views/Details/Details'
import PcDetails from './views/PcDetails/PcDetails'
import Index from './views/Index/Index'
import PcFooter from './views/PcFooter/PcFooter'
import PcIndex from './views/PcIndex/PcIndex'

class App extends Component<
    any,
    {
        isMobile: boolean
        renderDom: boolean
        singleMode: boolean
    }
> {
    id: string
    constructor(props) {
        super(props)
        this.state = {
            isMobile: browserInfo.versions.mobile,
            renderDom: false,
            singleMode: false,
        }
    }
    componentDidMount() {
        axios({
            method: 'get',
            url: ' /api/display/end',
        }).then((res: any) => {
            const locationParams = urlSearch(window.location.href)
            const single = res.data.data.DisplayEnd === 'Single' ? true : false
            if (single) {
                if (locationParams.id) {
                    sessionStorage.setItem('single', locationParams.id)
                    this.id = locationParams.id
                } else {
                    this.id = sessionStorage.getItem('single')
                }
            }
            this.setState({
                renderDom: true,
                singleMode: single,
            })
        })
    }

    public render() {
        if (!this.state.renderDom) return null
        const isMobile = this.state.isMobile
        const routerDom = this.state.singleMode ? (
            <>
                <Redirect
                    from="/"
                    to={{
                        pathname: '/single',
                        search: `id=${this.id}`,
                    }}
                ></Redirect>
                <Route path="/single" component={isMobile ? Details : PcDetails}></Route>
            </>
        ) : (
            <>
                <Route path="/" exact component={isMobile ? Index : PcIndex}></Route>
                <Route path="/detail" exact component={isMobile ? Details : PcDetails}></Route>
            </>
        )
        const dom = <BrowserRouter>{routerDom}</BrowserRouter>
        return dom
    }
}

export default App
